export enum RoutingActionEnum {
  SEARCH = '',
  INSERT = 'create',
  EDIT = 'edit',
  LOGIN = 'login',
}
